module.exports = __webpack_public_path__ + "static/media/yellow-green.1e8972e5.png";